export default __webpack_public_path__ + "static/logo-a967ea70d7eadf7ff3ebb685a05b7959.png";